var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 535 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filler"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 261,
    cy: 63,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 66,
    cy: 258,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 456,
    cy: 258,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 261,
    cy: 454,
    r: 50
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cross"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 66,
    cy: 63,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 456,
    cy: 63,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 261,
    cy: 258,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 66,
    cy: 454,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 456,
    cy: 454,
    r: 50
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: -6.5,
    y: 63.5,
    width: 102.517,
    height: 655.488,
    rx: 51.2583,
    transform: "rotate(-45 -6.5 63.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 457,
    y: -8.99017,
    width: 102.517,
    height: 655.488,
    rx: 51.2583,
    transform: "rotate(45 457 -8.99017)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 535,
    height: 517,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.c4dcf2c4d66db41e4937b3145dd8213c.svg";
export { ForwardRef as ReactComponent };